var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55942528,5.36772096 L0.57511296,5.36772096 C0.257482865,5.36772096 0,5.1102381 0,4.792608 L0,1.34193024 C0,1.02430014 0.257482865,0.76681728 0.57511296,0.76681728 L5.55942528,0.76681728 C5.87705538,0.76681728 6.13453824,1.02430014 6.13453824,1.34193024 L6.13453824,4.792608 C6.13453824,5.1102381 5.87705538,5.36772096 5.55942528,5.36772096 Z M1.34193024,1.4377824 C0.971365789,1.4377824 0.67096512,1.73818307 0.67096512,2.10874752 C0.67096512,2.47931197 0.971365789,2.77971264 1.34193024,2.77971264 C1.71249469,2.77971264 2.01289536,2.47931197 2.01289536,2.10874752 C2.01289536,1.73818307 1.71249469,1.4377824 1.34193024,1.4377824 Z M0.76681728,4.60090368 L5.36772096,4.60090368 L5.36772096,3.25897344 L4.31915824,2.21041072 C4.26301283,2.15426531 4.17197725,2.15426531 4.11581986,2.21041072 L2.49215616,3.8340864 L1.82700208,3.16893232 C1.77085667,3.11278691 1.67982109,3.11278691 1.6236637,3.16893232 L0.76681728,4.02579072 L0.76681728,4.60090368 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.46d816031e7a03e57834c12ee2d2d9d8.svg";
export { ForwardRef as ReactComponent };